import { Button, FormControl, Grid, Typography } from '@material-ui/core';
import * as Icons from '@material-ui/icons';
import jsConvert from 'js-convert-case/lib';
import React from 'react';
import { DataApi } from '../../../providers/api-provider';
import Dialog from './Dialog';
import { handleStateChangeFromProps } from './helpers';

export default class IconInput extends React.Component {
    state = {
        error: undefined,
        value: '',
        enabled: '',
        onChange: null,
        type: 'text',
        name: '',
        title: '',
        width: 12,
        extra: {},
        disabled: false,
        className: '',
        autoComplete: true,
        description: '',
        hidden: false,
        required: false,
        icons: [],
        chooseLoading: false,
        chooseDialog: false,
    }
    /*
    -----------------------------------------------------------------------
    API Functions
    -----------------------------------------------------------------------
    */
    componentDidMount() {
        this.fetchIcons();
    }
    //Fetch Icons
    fetchIcons = async () => {
        try {
            let res = await DataApi.getMany('perks');
            this.setState({ icons: res.data });
        } catch (e) {

        }
    }
    /*
    -----------------------------------------------------------------------
    RENDER Functions
    -----------------------------------------------------------------------
    */
    static getDerivedStateFromProps(nextProps, prevState) {
        return handleStateChangeFromProps(nextProps, prevState)
    }
    performChooseIconAction = (icon) => {
        /* this.setState({
            value: this.state.tempValue,
            chooseDialog: false,
        }); */
        this.state.onChange({
            target: {
                type: 'icon',
                value: icon,
                name: this.state.name,
            }
        });
        this.hideChooseDialog();
    };
    //
    showChooseDialog = () => {
        this.setState({ chooseDialog: true, tempValue: this.state.value });
    }
    hideChooseDialog = () => {
        this.setState({ chooseDialog: false });
    }
    renderChooseIcon = () => {
        const { icons, chooseLoading, chooseDialog, tempValue } = this.state;
        return (<Dialog
            show={chooseDialog}
            title={'Choose Icon'}
            onClick={false}
            triggerHide={this.hideChooseDialog}
            loading={chooseLoading}
            contentPadding={true}
            maxWidth={'lg'}
        >
            <Grid container spacing={1}>
                {
                    icons.map((icon, key) => {
                        if (typeof (Icons[jsConvert.toPascalCase(icon.icon)]) === 'undefined')
                            return <span key={'icon-' + icon.icon} />;
                        const Icon = Icons[jsConvert.toPascalCase(icon.icon)];
                        return (
                            <Grid Grid key={'icon-' + icon.icon} sm={4} md={3} item >
                                <Button
                                    onClick={() => this.performChooseIconAction(icon.icon)}
                                    style={{ textTransform: 'none' }}
                                    color={tempValue !== icon.icon ? 'default' : 'primary'}
                                    variant={'outlined'}
                                    fullWidth
                                >
                                    <Icon className='floatL' fontSize="large" />
                                    <Typography style={{ margin: 5, fontSize: '12px' }}>{icon.label}</Typography>
                                </Button>
                            </Grid>
                        )
                    }
                    )
                }
            </Grid>
        </Dialog >);
    }
    render() {
        const { error, value, enabled, onChange, type, name, title, width, disabled, extra,
            className, autoComplete, description, hidden, required } = this.state;

        if (hidden)
            return <div />

        let processedValue = value;
        if (type === 'datetime-local' && processedValue)
            processedValue = value.replace(' ', 'T');
        const Icon = typeof (Icons[jsConvert.toPascalCase(value)]) !== 'undefined' ? Icons[jsConvert.toPascalCase(value)] : Icons['Error'];
        return (
            <Grid item xs={12} sm={width ? width : 12} className={className} data-form-element={name}>
                <FormControl margin={this.props.margin || "normal"} fullWidth error={error && enabled}>
                    <Button variant="outlined" style={{ marginTop: 9 }} onClick={this.showChooseDialog}
                        color={error && enabled ? 'secondary' : 'default'}
                    >
                        {value && <Icon className='floatL' fontSize="large" style={{
                            position: 'absolute',
                            left: 10
                        }} />
                        }
                        <Typography style={{ margin: 5, fontSize: '12px' }}>{value || 'Choose Icon'}</Typography>
                    </Button>
                </FormControl>
                {this.renderChooseIcon()}
            </Grid>
        );
    }
}